<script>
import Icon from "@/components/atoms/icon";
import Titre from "@/components/atoms/titre";
import Button from "@/components/atoms/button";
import Popin from "@/containers/popin-adaptive";
import Table from "@/components/molecules/table";

export default {
  name: "ContactInfosCorapro",
  components: { Icon,
    Titre,
    Button,
    Popin,
    Table },
  props: {
    contact: {
      type: Object,
      required: false,
      default: null
    },
    contactsTable: {
      type: Array,
      required: false,
      default: null
    },
    showContact: {
      type: Boolean,
      required: false,
      default: false
    },
    magasinName: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>
<template>
  <div class="c-corapro-frame c-corapro-contact">
    <Titre
      tag="h3"
      class="u-mb-xs"
      size="xxs"
    >
      Un interlocuteur unique pour vous
    </Titre>
    <p class="u-font-14  u-mb-xs">
      De l’élaboration du devis à la livraison, corapro est là pour <strong>vous accompagner et vous proposer un service adapté à vos besoins.</strong>
    </p>
    <div>
      <p class="u-font-14 u-mb-sm">
        Vous êtes rattaché au magasin de <strong>{{ magasinName }}</strong>. Votre contact commercial est :
      </p>
      <ul
        v-if="showContact"
        class="c-corapro-contact__list"
      >
        <li>
          <Icon
            name="commercial-pro"
            size="sm"
            variant="primary"
          />
          <p>{{ contact.prenom_referent }} {{ contact.nom_referent }}</p>
        </li>
        <li>
          <Icon
            name="phone"
            size="sm"
            variant="primary"
          />
          <span>
            <a :href="`tel:${contact.tel_referent}`">{{ contact.tel_referent }}</a>
            <br>
            <a :href="`tel:${contact.mobile_referent}`">{{ contact.mobile_referent }}</a>
          </span>
        </li>
        <li>
          <Icon
            name="email"
            size="sm"
            variant="primary"
          />
          <p><a :href="`mailto:${contact.mail_referent}`">{{ contact.mail_referent }}</a></p>
        </li>
      </ul>
      <Button
        v-else
        link
        variant="primary"
        @click="$refs.tableContactsCorapro.show()"
      >
        Consulter la liste des magasins
      </Button>
    </div>

    <!-- Popin -->

    <Popin
      ref="tableContactsCorapro"
      size="lg100"
      page-back
      page
    >
      <Titre
        tag="h3"
        class="c-contact-infos-corapro_popin-title u-font-24 u-font-700"
      >
        Liste des magasins proposant ce service
      </Titre>
      <Table
        responsive="true"
        no-bordered
        size="full"
        class="c-contact-infos-corapro_popin-container"
      >
        <thead class="c-contact-infos-corapro_popin-header-tableau">
          <tr>
            <th>Magasin</th>
            <th>Contact</th>
            <th>Télephone</th>
            <th>Téléphone mobile</th>
            <th>Adresse email</th>
          </tr>
        </thead>
        <tbody class="c-contact-infos-corapro_popin-body-tableau">
          <tr
            v-for="(contact, i) in contactsTable"
            :key="`contactPro${i}`"
          >
            <td>
              {{ contact.magasin }}
            </td>
            <td>
              {{ contact.prenom_referent }}
              {{ contact.nom_referent }}
            </td>
            <td>
              <a :href="`tel:${contact.tel_referent}`">{{ contact.tel_referent }}</a>
            </td>
            <td>
              <a :href="`tel:${contact.mobile_referent}`">{{ contact.mobile_referent }}</a>
            </td>
            <td>
              <a :href="`mailto:${contact.mail_referent}`">
                {{ contact.mail_referent }}
              </a>
            </td>
          </tr>
        </tbody>
      </Table>
    </Popin>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/contact-infos-corapro.scss";
@import "@/assets/styles/globals/cms.scss";
@import "@/assets/styles/components/table.scss"
</style>
